import React, {Component} from "react"
import {connect} from 'react-redux';

import moment from 'moment';

import Layout from "../../../components/Layout"
import leng from "../../../data"

import {
    DataTable,
    TableContainer,
    TableToolbar,
    TableToolbarContent,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    Table,
    TableCell,
    Pagination,
    DataTableSkeleton,
    TooltipDefinition
} from "carbon-components-react"
import {ErrorFilled16, CheckmarkFilled16, Time16} from "@carbon/icons-react"
import "./index.scss"

import {
    files_action_count,
    files_action_fetch
} from '../../../store/actions/files';


const headers = [
    {key: "progress_icon", header: ""},
    {key: "progressTitle", header: leng.captura.processando_table_header.table[0]},
    {key: "agent", header: leng.captura.processando_table_header.table[1]},
    {key: "user", header: leng.captura.processando_table_header.table[3]},
    {key: "fileLimit", header: leng.captura.processando_table_header.table[4]},
    {key: "timestamp", header: leng.captura.processando_table_header.table[5]},
    {key: "messageErrorLimit", header: leng.captura.processando_table_header.table[6]},
];

class Processando extends Component {

    state = {
        start: 0,
        pageSize: 20,
        page: 1
    };

    componentDidMount() {
        this.props.countFiles();
        this.props.fetchData({
            pageSize: 20,
            page: 1
        });
    }


    async onChangePagination(arg1, arg2, arg3) {

        await this.setState(prevState => ({
            start: this.state.start == 0 ? (arg1.page * arg1.pageSize) - 20 : this.state.start * arg1.page,
            pageSize: arg1.pageSize,
            page: arg1.page,
        }))


        await this.props.fetchData({
            start: this.state.start == 0 ? (arg1.page * arg1.pageSize) - 20 : this.state.start * arg1.page,
            pageSize: arg1.pageSize,
            page: arg1.page,
        });
    }

    handleDownload = (originalFile, originalName, bucket) => e => {
        e.preventDefault();
        alert(originalName);
        var name = originalName.split('/');
        var nameOriginal = name[name.length - 1];
        this.props.downloadFiles(originalFile, nameOriginal, bucket);
    };

    render() {
        let {data, countRepository, isLoading} = this.props;

        let rows = data;
        rows =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                        timestamp: moment(execution.statusChangeDate).format('D MMM YYYY H:mm'),
                        sortDate: new Date(execution.statusChangeDate),
                        progressTitle: execution.progress === 100 ? "Completed" : "In progress",
                        fileLimit: (typeof execution.originalName === "undefined") ? (
                            '') : (execution.originalName.length > 15 ? (
                            <TooltipDefinition tooltipText={execution.originalName}>
                                {execution.originalName.substring(0, 15) + "..."}
                            </TooltipDefinition>
                        ) : execution.originalName)
                        ,
                        messageErrorLimit: execution.message.length > 45 ? (
                            <TooltipDefinition tooltipText={execution.message} align='end'>
                                {execution.message.substring(0, 42) + "..."}
                            </TooltipDefinition>
                        ) : execution.message,
                        messageError: execution.status === 0 ? " - " : execution.message,
                        progress_icon: execution.status === 0 ? execution.progress < 100 ?
                            <Time16 className={"icon-success-table"}/> : (
                                <CheckmarkFilled16 className={"icon-success-table"}/>) : (
                            <ErrorFilled16 className={"icon-error-table"}/>)
                    };
                })
                : [];
        if (rows?.length > 0) rows.sort((a, b) => b.sortDate - a.sortDate);
        // console.log(data);
        return (
            <Layout>
                <div className="section">
                    <div className="section-heading">
                        <br/>
                        <p></p>
                        <h1>{leng.sideBar.jobs.links[0]}</h1>
                        <br/>
                    </div>
                </div>
                <div className="section-light">
                    <div className="section-light-heading">
                        <div className="file-upload-container">
                            <div>
                                {isLoading ? (
                                    <DataTableSkeleton/>
                                ) : (
                                    <DataTable rows={rows} headers={headers}>
                                        {({
                                              rows,
                                              headers,
                                              getHeaderProps,
                                              getRowProps,
                                              getTableProps,
                                              getSelectionProps,
                                              onInputChange,
                                          }) => (
                                            <TableContainer title={leng.captura.processando.table_title}
                                                            description={countRepository + " Items"}
                                                            className="upload-table">
                                                <TableToolbar>
                                                    <TableToolbarContent>
                                                    </TableToolbarContent>
                                                </TableToolbar>
                                                <Table {...getTableProps()}>
                                                    <TableHead>
                                                        <TableRow>
                                                            {headers.map((header) => (
                                                                <TableHeader
                                                                    key={header.key}
                                                                    {...getHeaderProps({header})}
                                                                >
                                                                    {header.header}
                                                                </TableHeader>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {rows.map((row) => (
                                                            <TableRow
                                                                className="upload-row"
                                                                key={row.id}
                                                                {...getRowProps({row})}
                                                            >
                                                                {row.cells.map((cell) => (
                                                                    <TableCell key={cell.id}>
                                                                        {cell.value}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                <Pagination
                                                    className="paginator"
                                                    totalItems={countRepository}
                                                    pageSizes={[20, 40]}
                                                    backwardText="Previous"
                                                    forwardText="Next"
                                                    pageSize={this.state.pageSize}
                                                    itemsPerPageText={"Items per page"}
                                                    page={this.state.page}
                                                    onChange={(arg1, arg2, arg3) => {
                                                        this.onChangePagination(arg1, arg2, arg3);
                                                    }}
                                                >

                                                </Pagination>
                                            </TableContainer>
                                        )}
                                    </DataTable>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}


const mapStateToProps = ({files}) => files;

const mapDispatchToProps = dispatch => ({
    countFiles: () => dispatch(files_action_count()),
    fetchData: params => dispatch(files_action_fetch(params)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Processando);
